import styled from '@xstyled/styled-components';

export const DoorWrapper = styled.button<{ url: string }>`
  width: 26%;
  padding: 0;
  margin: 0px auto;
  border: 15px solid #d4855a;
  position: relative;
  top: 19px;
  border-bottom: none;
  background-image: url(${p => p.url});
  background-position: center;
  background-size: cover;
  position: relative;
  cursor: pointer;

  .swing-right-fwd {
    animation: swing-right-fwd 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    border-left: 12px solid #dc9d6f;

    @media (max-width: 639.98px) {
      border-left-width: 8px;
    }
  }

  @keyframes swing-right-fwd {
    0% {
      -webkit-transform: rotateY(0);
      transform: rotateY(0);
      -webkit-transform-origin: right;
      transform-origin: right;
    }
    100% {
      -webkit-transform: perspective(75rem) rotateY(110deg);
      transform: perspective(75rem) rotateY(110deg);
      -webkit-transform-origin: right;
      transform-origin: right;
    }
  }

  @media (max-width: 639.98px) {
    border-width: 8px;

    @keyframes swing-right-fwd {
      0% {
        -webkit-transform: rotateY(0);
        transform: rotateY(0);
        -webkit-transform-origin: right;
        transform-origin: right;
      }
      100% {
        -webkit-transform: perspective(50rem) rotateY(110deg);
        transform: perspective(50rem) rotateY(110deg);
        -webkit-transform-origin: right;
        transform-origin: right;
      }
    }
  }
`;
